export function trimEntity<T>(entity: T): T {
  switch (typeof entity) {
    case 'string':
      return entity.trim() as T;
    case 'object':
      if (Array.isArray(entity)) {
        return entity.map(trimEntity) as unknown as T;
      }
      if (entity === null) {
        return entity;
      }
      return Object.fromEntries(
        Object.entries(entity).map(([key, val]) => [key, trimEntity(val)]),
      ) as T;
    default:
      return entity;
  }
}
